<mat-form-field>
  <input
    matInput
    (keyup)="applyFilter($event.target.value)"
    placeholder="Filter"
  />
</mat-form-field>

<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
      <td mat-cell *matCellDef="let row">
        {{ row.email }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let row">
        {{ row.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="school">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>School</th>
      <td mat-cell *matCellDef="let row">
        {{ row.school }}
      </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Role</th>
      <td mat-cell *matCellDef="let row">
        {{ row.role }}
      </td>
    </ng-container>

    <ng-container matColumnDef="everLoggedIn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ever Logged In</th>
      <td mat-cell *matCellDef="let row">
        {{ row.everLoggedIn }}
      </td>
    </ng-container>

    <ng-container matColumnDef="lastLoggedIn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Logged In</th>
      <td mat-cell *matCellDef="let row">
        {{ row.lastLogin }}
      </td>
    </ng-container>

    <ng-container
      *ngFor="let date of dates"
      [matColumnDef]="date.toLowerCase()"
    >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ date }}</th>
      <td mat-cell *matCellDef="let row">
        {{ row.views[date].viewCount }}
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
</div>
